import type { ProPayoutSummaryResource } from '@/features/payouts/api/resources/pro-analytics'
import type { ProPayoutSummary } from './ProPayoutSummary'

/**
 * Maps a pro's payout totals.
 */
export function mapProPayoutSummaryResourceToProPayoutSummary(
  resource: ProPayoutSummaryResource,
): ProPayoutSummary {
  return {
    earningsYearToDate: resource.earnings_ytd,
    lifetimeEarnings: resource.earnings_lifetime,
    pendingEarnings: resource.pending,
  }
}
